import { CreateDeviceDto, FormDeviceDto, RowDeviceDto, UpdateDeviceDto } from "@/dtos";
import { Device, DeviceModel, Place } from "@/entities";
import { getDeviceStatus} from "@/helpers/options";

export const formatRowDeviceDto = async (devices: Device[]): Promise<RowDeviceDto[]> => {
    return devices.map((x) => {
        const row: RowDeviceDto = {
            ...x,
            status_device: getDeviceStatus(parseInt(x.status)).label,
            device_model_name: x.device_model.name,
            place_name: x.place.name,
            active: x.is_active ? 'Activo' : 'Inactivo',
        }
        return row;
    });
}

export const formatDeviceDto = async (formDevice: FormDeviceDto, isCreate: boolean) => {
    const place = { id: formDevice.place_id } as Place;
    const deviceModel = { id: formDevice.device_model_id } as DeviceModel;

    const deviceDto = {
        name: formDevice.name,
        place: place,
        device_model: deviceModel,
        firmware: formDevice.firmware,
        status: formDevice.status.toString()
    }

    return (isCreate) ? deviceDto as CreateDeviceDto : deviceDto as UpdateDeviceDto
}